import * as R from 'ramda'

export const getIsFetchingBlogList = R.path([
  'blog',
  'processing',
  'getBlogList'
])

export const getBlogList = R.path(['blog', 'blogList'])

export const getIsFetchingBlogDetail = R.path([
  'blog',
  'processing',
  'getBlogDetail'
])

export const getBlogDetail = R.path(['blog', 'blogDetail'])

export const getIsCreateOrUpdatingBlog = R.path([
  'blog',
  'processing',
  'createOrUpdatingBlog'
])

export const getIsFetchingBlogStatistics = R.path([
  'blog',
  'processing',
  'getBlogStatistics'
])

export const getBlogStatistics = R.path(['blog', 'blogStatistics'])
